import { render } from "./AuthorApplication.vue?vue&type=template&id=4a8ea668&scoped=true"
import script from "./AuthorApplication.vue?vue&type=script&lang=js"
export * from "./AuthorApplication.vue?vue&type=script&lang=js"

import "./AuthorApplication.vue?vue&type=style&index=0&id=4a8ea668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8ea668"]])

export default __exports__